import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import cloneDeep from 'lodash/cloneDeep';
import React, { useMemo } from 'react';
import PreviewContainer from '@/components/WidgetPreviewContainer';
import EmbedLayout from '@/components/widget/Layout';
import { uuid } from '@/utils/uuid';
import { isFormSection } from '@/utils/reporting/widgetQueries';
import styles from './styles.module.scss'; // const PREFIX = 'components: Editor: Preview:';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const EditorPreview = _ref => {
  let {
    elementId,
    className,
    activeSectionId,
    focusedSectionId,
    widget,
    editing = false,
    hasErrors,
    originFileType,
    reportingWidget,
    workbookFile,
    workbookMeta,
    textOverrides,
    isDataButtonHidden = false,
    isResolutionControlHidden = false,
    isResolutionGroupControlHidden = true,
    isPreviewContainerCollapsed = false,
    isZoomControlHidden = false,
    isAccreditationHidden = false,
    isToolbarVisible = false,
    isScrollable = true,
    isAiExperiment,
    initialResolutionStrategy,
    zoomLevel,
    defaultZoomLevel,
    defaultAspectRatio,
    defaultPreviewResolution,
    containerMinSize,
    previewGroups,
    updatedAt = 0,
    children,
    onWidgetUpdate = () => undefined,
    onPreviewResolutionChange = () => undefined,
    onEditData = () => undefined,
    onEditTheme = () => undefined,
    onEditDataErrors = () => undefined,
    onSave,
    onShare
  } = _ref;
  // Turn into a subscriber of updating widget
  // or another subscriber to the reporting widget
  const focusedWidget = useMemo(() => {
    if (!focusedSectionId) return null;
    const clone = cloneDeep(widget);
    const cloneSections = clone.sections || {};
    const focusedSection = cloneSections[focusedSectionId];
    if (!focusedSection) return null; // Remove padding from focused section

    focusedSection.config.styles = _objectSpread(_objectSpread({}, focusedSection.config.styles), {}, {
      paddingTop: '0',
      paddingRight: '0',
      paddingBottom: '0',
      paddingLeft: '0'
    }); // Keep only the active section
    // decoding its selections

    Object.keys(cloneSections).forEach(sectionId => {
      if (sectionId !== focusedSectionId) {
        // @ts-ignore
        delete clone.sections[sectionId];
      }
    }); // Unless section is form convert
    // to a subscriber of reporter widget

    if (!isFormSection(focusedSection)) {
      delete clone.workbook;
      clone.reportingWidget = {
        id: [`${reportingWidget.id || uuid()}`, `${elementId || ''}`].join('-')
      };
    } // Remove any layout & widget padding


    delete clone.layout;
    clone.config.layout = 'none';
    clone.config.styles = _objectSpread(_objectSpread({}, clone.config.styles), {}, {
      widgetPaddingTop: '0',
      widgetPaddingRight: '0',
      widgetPaddingBottom: '0',
      widgetPaddingLeft: '0'
    });
    clone.updatedAt = updatedAt;
    return clone;
  }, [widget, reportingWidget, focusedSectionId, updatedAt, elementId]);
  return /*#__PURE__*/_jsxs(PreviewContainer, _objectSpread(_objectSpread({}, elementId && {
    id: elementId
  }), {}, {
    widget: widget,
    className: clsx(styles.container, className || ''),
    editing: editing,
    hasErrors: hasErrors,
    originFileType: originFileType,
    isDataButtonHidden: isDataButtonHidden,
    isResolutionControlHidden: isResolutionControlHidden,
    isResolutionGroupControlHidden: isResolutionGroupControlHidden,
    isZoomControlHidden: isZoomControlHidden,
    isPreviewContainerCollapsed: isPreviewContainerCollapsed,
    isToolbarVisible: isToolbarVisible,
    isScrollable: isScrollable,
    isAiExperiment: isAiExperiment,
    initialResolutionStrategy: initialResolutionStrategy,
    zoomLevel: zoomLevel,
    defaultZoomLevel: defaultZoomLevel,
    defaultAspectRatio: defaultAspectRatio,
    defaultPreviewResolution: defaultPreviewResolution,
    containerMinSize: containerMinSize,
    previewGroups: previewGroups,
    textOverrides: textOverrides,
    updatedAt: updatedAt,
    onPreviewResolutionChange: onPreviewResolutionChange,
    onEditData: onEditData,
    onEditDataErrors: onEditDataErrors,
    onEditTheme: onEditTheme,
    onShare: onShare,
    onSave: onSave,
    onWidgetUpdate: onWidgetUpdate,
    children: [/*#__PURE__*/_jsx(EmbedLayout, {
      widgetId: widget.id || '',
      activeSectionId: activeSectionId,
      reportingWidgetId: reportingWidget.id,
      editing: editing,
      workbook: workbookFile,
      workbookMeta: workbookMeta,
      updatedAt: updatedAt,
      fonts: (focusedWidget === null || focusedWidget === void 0 ? void 0 : focusedWidget.fonts) || widget.fonts,
      config: (focusedWidget === null || focusedWidget === void 0 ? void 0 : focusedWidget.config) || widget.config,
      sections: (focusedWidget === null || focusedWidget === void 0 ? void 0 : focusedWidget.sections) || (widget === null || widget === void 0 ? void 0 : widget.sections) || {},
      subscriptionActive: (focusedWidget ? true : widget.subscriptionActive) || isAccreditationHidden
    }), children]
  }));
};

export default EditorPreview;